


























import { Vue, Component, Prop } from 'vue-property-decorator';
import { Location } from 'vue-router';
import wave from '../../directives/wave';

@Component({
  name: 'BaseLink',
  directives: {
    wave,
  },
})
export default class BaseLink extends Vue {
  @Prop({ default: false }) disabled: boolean;
  @Prop() to: string | Location;
  @Prop() href: string;
  @Prop() normal: boolean;

  get tabIndex() {
    return this.disabled ? -1 : 0;
  }
}
